exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar{\r\n    padding: 5px 20px;\r\n    border: none;\r\n    margin-bottom: -5px !important;\r\n}\r\n.navbar-brand{\r\n    font-size: 20px;\r\n    position: relative;\r\n    margin-left: 10px !important;\r\n}\r\n.div-body{\r\n    height: 550px;\r\n    padding: 20px 20px;\r\n}\r\n.popup-screen{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    background-color: rgba(0,0,0,0.5);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 461
// module chunks = 1